import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { Link } from 'gatsby';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import DangerBoxURL from 'components/1440p_Series_CGI_List/DangerBoxURL';
import { EuiSpacer } from '@elastic/eui';
import IntroCards from 'components/1440p_Series_CGI_List/Smarthome_Menu/smarthomeCGI';
import NavButtons from 'components/1440p_Series_CGI_List/NavButtons';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEOHelmet title='UltraHD Serien (2K+ 1440p & 4K 2160p) CGI Liste :: Smarthome Menu' dateChanged='2021-09-20' author='Mike Polinowski' tag='INSTAR IP Camera' description='UltraHD Serien (2K+ 1440p & 4K 2160p) CGI Liste :: Smarthome Menu' image='/images/Search/AU_SearchThumb_CGICommands_1440p.png' twitter='/images/Search/AU_SearchThumb_CGICommands_1440p.webp' location={props.location.pathname} mdxType="SEOHelmet" />
    <BreadCrumbs locationBC={props.location} locationDE={props.location.pathname} locationEN='/en/1440p_Series_CGI_List/Smarthome_Menu/' locationFR='/fr/1440p_Series_CGI_List/Smarthome_Menu/' crumbLabel="Smarthome" mdxType="BreadCrumbs" />
    <NavButtons mdxType="NavButtons" />
    <EuiSpacer mdxType="EuiSpacer" />
    <DangerBoxURL mdxType="DangerBoxURL" />
    <EuiSpacer mdxType="EuiSpacer" />
    <IntroCards mdxType="IntroCards" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      